import { useContext } from 'react';
import { store } from '../store';
import { usePostRequest } from '../../core/coreUseRequest';

/** useGenerateCharge ::  {} */
export default function useGenerateCharge() {
	const { dispatch } = useContext(store);

	return usePostRequest({
		url: '/create/product/invoice/',
		queryName: 'getProductInvoices',
		dispatch,
		successFn: () =>
			dispatch({
				type: 'close dialog'
			})
	});
}
